export default "__VITE_ASSET__D0kZLEjr__"